import { arcStore } from '../store/ArcStore';
import { mutatorAction } from 'satcheljs';
import { ArcApiResponse } from '../service/schema/arcApiResponse';

export default mutatorAction('setLeftNavIrisState', function setLeftNavIrisState(
    state: ArcApiResponse
): void {
    arcStore.message = state.ad.body;
    arcStore.iconUri = state.ad.icon;
    arcStore.textColor = state.ad.textColor;
    arcStore.userRedirectionUrl = state.ad.ctaUrl;
    arcStore.trackingBaseUri = state.tracking.baseUri;
    arcStore.impressionBaseUri = state.prm._imp;
});
